import React, {PureComponent, ReactNode, StrictMode} from "react";
import {Transition} from "@headlessui/react";

export class FilterSkeleton extends PureComponent {
    render(): ReactNode {
        return (
            <div className="w-full col-span-6 md:col-span-4 mb-2 relative">
                <Transition
                    appear={true}
                    show={true}
                    enter={"transition transform duration-300 ease-out"}
                    enterFrom={"translate-x-4 opacity-0"}
                    enterTo={"translate-x-0 opacity-100"}
                    leave={"transition transform duration-300 ease-in"}
                    leaveFrom={"opacity-100"}
                    leaveTo={"opacity-0"}>
                    <StrictMode>
                            <div className={'animate-pulse col-span-6 relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full h-full px-12 py-4 mb-2 pr-6 text-gray-700'}>
                            </div>
                    </StrictMode>
                </Transition>
            </div>
        );
    }
}


